import React, { useEffect, useState } from 'react'
import { WhiteSpace, WingBlank } from 'antd-mobile'
import { Button, DotLoading, Toast } from 'antd-mobile-v5'
import Signature from '../../components/FormTools/Signature'
import { useGetOssSignature, useIeDetail, useIeStatementDetail, useSubmitIeStatement } from '../../services/hooks'
import { formatDate, getParameterByName } from '../../components/common/utils'

import styles from './IeStatement.module.css'
import { Modal } from 'antd'
import { useIntl } from 'react-intl'

const IEStatement = () => {
  const code = getParameterByName('code')
  const { data: ossSignature } = useGetOssSignature('OWSI')
  const [signData, setSignData] = useState({
    handwrittenSignatureCandidateUnderstanding1: '',
    handwrittenSignatureCandidateUnderstanding2: '',
    handwrittenSignatureCandidateUnderstanding3: '',
    handwrittenSignatureCandidateUnderstanding4: '',
    handwrittenSignatureCandidateUnderstanding5: '',
    handwrittenSignatureCandidateUnderstanding6: '',
    handwrittenSignatureCandidateUnderstanding7: '',
  })

  const { data: detail, loading: detailRequesting } = useIeDetail()
  const { run: getSignatureDetail, data: ieSignatureDetail, loading: signatureRequesting } = useIeStatementDetail(code)
  const { run, loading } = useSubmitIeStatement({
    onSuccess: (data) => {
      Toast.show({
        icon: 'success',
        content: '提交成功',
      })
    },
  })

  const submit = () => {
    const {
      handwrittenSignatureCandidateUnderstanding1,
      handwrittenSignatureCandidateUnderstanding2,
      handwrittenSignatureCandidateUnderstanding3,
      handwrittenSignatureCandidateUnderstanding4,
      handwrittenSignatureCandidateUnderstanding5,
      handwrittenSignatureCandidateUnderstanding6,
      handwrittenSignatureCandidateUnderstanding7,
    } = signData
    if (
      !handwrittenSignatureCandidateUnderstanding1 ||
      !handwrittenSignatureCandidateUnderstanding2 ||
      !handwrittenSignatureCandidateUnderstanding3 ||
      !handwrittenSignatureCandidateUnderstanding4 ||
      !handwrittenSignatureCandidateUnderstanding5 ||
      !handwrittenSignatureCandidateUnderstanding6 ||
      !handwrittenSignatureCandidateUnderstanding7
    ) {
      Toast.show({
        content: '请阅读并完成签名。',
      })
      return
    }
    run({
      ...signData,
      code: detail.code,
    })
  }

  const updateSignData = (update) => setSignData({ ...signData, ...update })
  const { formatMessage } = useIntl()

  useEffect(() => {
    if (code === null && detail && detail.code === null) {
      Modal.error({
        title: formatMessage({ id: 'common-errorTitle' }),
        content: formatMessage({ id: 'owsi-not-found' }),
      })
      return
    }
    if (code) getSignatureDetail(code)
  }, [detail])

  if (code === null && detail && detail.code === null) {
    return null
  }

  if (detailRequesting || signatureRequesting) return <DotLoading />

  return (
    <div className={styles.wrapper}>
      <WingBlank>
        <WhiteSpace />
        <h2>IE 教练考试候选人了解声明书</h2>
        <p>
          此声明告知您有关获得 PADI 教练考试(IE)通过证书之规定。您有责任阅读以下
          说明并签名。在您阅读并就产生的任何问题与考试官讨论确认后，请在此声明 书上签名并注明日期。
        </p>
        <p>
          <strong>1. 潜水理论考试</strong>
        </p>
        <p>
          笔试项目包括物理学、生理学、休闲潜水计划(RDP)、潜水技巧与环境，以
          及装备。每一科考试中包含12个选择题。您必须达到该科分数的75%以上才
          算及格。考试时间为1小时30分钟，您必须在此时间内完成5科共60题的题
          目。如果您的5科考试中有一科不及格，您可以补考。但只可以补考一科，补
          考时间是30分钟内要完成12道题目。任何一科补考的最低及格成绩也是
          75%。2科以上的考试不及格，则将会因不合格而无法取得这次IE教练考试的 通过证书。
        </p>
        <p>
          <strong>2. PADI 系统、标准和程序考试</strong>
        </p>
        <p>
          这是可以翻阅书本的考试。考试时，您可以参考 PADI 教练手册(书本或是电 子版本)以及 PADI
          教学指引。考试题目包括是非题和选择题共50道。考试时
          间为1小时30分钟。及格分数为75%并且不能补考。考试分数低于75%，会因 不合格而无法取得这次IE教练考试的通过证书。
        </p>
        {code ? (
          <Signature
            title={'笔试考试签名'}
            initSignature={ieSignatureDetail.handwrittenSignatureCandidateUnderstanding1}
            modified={false}
          />
        ) : (
          <Signature
            title={'笔试考试签名'}
            filePath={'signature'}
            modified={true}
            oss={ossSignature}
            onSuccess={(imgUrl) => updateSignData({ handwrittenSignatureCandidateUnderstanding1: imgUrl })}
            onClear={() => updateSignData({ handwrittenSignatureCandidateUnderstanding1: '' })}
          />
        )}
        <WhiteSpace size="lg" />
        <p>
          <strong>3. 知识发展教学试教</strong>
        </p>
        <p>
          您收到的 IE 教练考试分配题目包括出自 PADI 系统的2个知识发展主题。如果
          您未能通过初次的试教，则第2个的主题就算是您的补考试教的题目。初次试
          教的及格分数是3.4分或以上。未满3.4分就算不及格，而您还有一次补考的机
          会。成功通过补考的分数必须在3.4分或以上。补考未满3.4分，则将会因不通 过而无法取得这次 IE 教练考试的通过证书。
        </p>
        {code ? (
          <Signature
            title={'知识发展评估签名'}
            initSignature={ieSignatureDetail.handwrittenSignatureCandidateUnderstanding2}
            modified={false}
          />
        ) : (
          <Signature
            title={'知识发展评估签名'}
            filePath={'signature'}
            modified={true}
            oss={ossSignature}
            onSuccess={(imgUrl) => updateSignData({ handwrittenSignatureCandidateUnderstanding2: imgUrl })}
            onClear={() => updateSignData({ handwrittenSignatureCandidateUnderstanding2: '' })}
          />
        )}
        <WhiteSpace size="lg" />
        <p>
          <strong>4. 平静水域教学试教</strong>
        </p>
        <p>
          您收到的 IE 考试分配题目包括出自 PADI 系统的2个平静水域主题。在平静水
          域教学试教期间，您必须要示范您所要教学的技巧;同时，技巧执行期间合格
          助教可能会有也可能没有，这取决于您的分配题目。示范未完成将得到1.0分
          (针对整个试教结果)。如果您的初次试教不成功，则第2个主题就是您补考
          试教的题目。初次试教的及格分数是3.4分或以上。未满3.4分就算不及格，而
          您还有一次补考的机会。成功通过补考的分数也必须在3.4分或以上。补考未 满3.4分，则将会因不通过而无法取得这次 IE
          教练考试的通过证书。
        </p>
        <p>
          <strong>5. 平静水域技巧示范评估</strong>
        </p>
        <p>
          为了要示范技巧的熟练度，您必须要展示一系列具有示范效果的技巧，其中包 括5项 PADI 系统的技巧。您的熟练度将根据
          PADI 平静水域评分表上的示范标 准来进行计分。
        </p>
        <ul>
          <li>a. 最低及格分数是5项技巧总分17分或以上，而每一项的分数不得低于3.0分。</li>
          <li>b. 5项总分达到17分，但其中一项技巧未达 3.0 分 ‒ (该技巧有一次补考机会)。</li>
          <li>c. 如果您在初次技巧评估的总分不超过17分，则您还有一次补考的机会，重新示范所有5项技巧。</li>
          <li>
            d.
            若初次技巧示范有2项以上的技巧仅得分1.0或2.0分，或是未通过补考，则将会因不通过而无法取得这次IE教练考试的通过证书
          </li>
        </ul>
        {code ? (
          <Signature
            title={'平静水域签名'}
            initSignature={ieSignatureDetail.handwrittenSignatureCandidateUnderstanding3}
            modified={false}
          />
        ) : (
          <Signature
            title={'平静水域签名'}
            filePath={'signature'}
            modified={true}
            oss={ossSignature}
            onSuccess={(imgUrl) => updateSignData({ handwrittenSignatureCandidateUnderstanding3: imgUrl })}
            onClear={() => updateSignData({ handwrittenSignatureCandidateUnderstanding3: '' })}
          />
        )}
        <WhiteSpace size="lg" />
        <p>
          <strong>6. 开放水域教学试教</strong>
        </p>
        <p>
          您收到的 IE 考试分配题目包括出自 PADI 系统的2个开放水域主题。在IE的这
          个部分，2个技巧要同时在一次开放水域潜水中执行，然后，2个分数平均。
          因此，没有补考。及格分数是平均3.4分或以上。平均分数不到3.4分，则会因 不合格而无法取得这次 IE
          教练考试的通过证书。
        </p>
        <p>
          <strong>7. 开放水域救援演示</strong>
        </p>
        <p>
          您将会被要求模拟示范在水面救援无意识/无呼吸潜水员的能力。这部分最重要
          的评分重点是在施行救援呼吸是否有正确适当2次大口的救援呼吸以及在评估
          期间正确适当的维持每五秒钟进行一次救援呼吸的周期。评分技巧项目如下:
        </p>
        <ul>
          <li>a. 接近</li>
          <li>b. 初始接触</li>
          <li>c. 进行初始的救援呼吸</li>
          <li>d. 建立浮力</li>
          <li>e. 保护和维持呼吸道畅通</li>
          <li>f. 周期性进行救援呼吸</li>
          <li>g. 装备移除</li>
          <li>h. 救援拖带</li>
        </ul>
        <p>
          在实施初次评分之前，考试官会进行一次明确的安排和表现简介。无法确实示
          范上述的技巧便无法通过考试。只有一次补考机会。补考失败，则将会因不合 格而无法取得这次IE教练考试的通过证书。
        </p>
        {code ? (
          <Signature
            title={'开放水域签名'}
            initSignature={ieSignatureDetail.handwrittenSignatureCandidateUnderstanding4}
            modified={false}
          />
        ) : (
          <Signature
            title={'开放水域签名'}
            filePath={'signature'}
            modified={true}
            oss={ossSignature}
            onSuccess={(imgUrl) => updateSignData({ handwrittenSignatureCandidateUnderstanding4: imgUrl })}
            onClear={() => updateSignData({ handwrittenSignatureCandidateUnderstanding4: '' })}
          />
        )}
        <WhiteSpace size="lg" />
        <p>
          <stron>8. 一般潜水技巧</stron>
        </p>
        <p>
          在平静水域和开放水域部分，考试官会针对您的一般潜水技巧，给予一个具体 的评分。您将被要求必须熟悉并具备通过 PADI
          系统所指定的所有技巧的能 力。您应该要依照 PADI 平静水域评分表上的示范标准，将技巧水平展示出具有
          模范榜样。如未通过此展示，则将会因不合格而无法取得这次IE教练考试的通 过证书，并且在下一次的 IE
          教练考试时，必须成功通过平静水域和开放水域2 部分。
        </p>
        <p>
          <stron>9. 专业素养</stron>
        </p>
        <p>
          考试官可以自行决定是否让您参加该次的IE教练考试。如果您的行为、态度、
          或是行动被视为不专业、不合宜或扰乱其它候选人，则我们必须请您离开考 场。被 PADI IE
          考试开除会使您丧失考试费，同时分数不予计算。此外，若您是
          因为以上原因而被请离开考场，则当您要参加其它IE时，必须先取得 PADI 的书 面同意书。
        </p>
        <p>
          <strong>10. 退款政策</strong>
        </p>
        <p>
          IE 教练考试的费用不能部分或完全退费。若要重复参加后续的IE教练考试项
          目，必须依照个别重复参加的项目支付费用(笔试、知识发展、平静水域和/或 开放水域)。
        </p>
        {code ? (
          <Signature
            title={'一般潜水技巧，专业素养，退款政策签名'}
            initSignature={ieSignatureDetail.handwrittenSignatureCandidateUnderstanding5}
            modified={false}
          />
        ) : (
          <Signature
            title={'一般潜水技巧，专业素养，退款政策签名'}
            filePath={'signature'}
            modified={true}
            oss={ossSignature}
            onSuccess={(imgUrl) => updateSignData({ handwrittenSignatureCandidateUnderstanding5: imgUrl })}
            onClear={() => updateSignData({ handwrittenSignatureCandidateUnderstanding5: '' })}
          />
        )}
        <WhiteSpace size="lg" />
        <p>
          <strong>11. 证书指引</strong>
        </p>
        <p>
          任意评估项未达到考试通过的标准将不能获得 OWSI 水肺教练证书，作为IE候
          选人必须成功完成初始IE的所有评估项，或者非初始IE的补考项目。在参加下一
          次IE考试前必须等待5天，以进行补强和复习。在初始IE中有3处或更多考核项未
          通过，或未能完成IE考试，须在参加下次IE考试时缴纳全部IE考试费。两次IE考 试未通过者，需要接受由 PADI
          指示的补强纠正计划，且在下次参加IE考试前必 须出示由课程总监签字的补强纠正完成表。
        </p>
        <p>
          <strong>12. 教学身份</strong>
        </p>
        <p>
          成功通过 IE 教练考试的候选人在 IDC/OWSI/IE 文书申请被处理完后会收到官方
          的通知，根据当地要求满足保险要求(如适用)后，即可进行教学。
        </p>
        {code ? (
          <Signature
            title={'证书指引和教学身份签名'}
            initSignature={ieSignatureDetail.handwrittenSignatureCandidateUnderstanding6}
            modified={false}
          />
        ) : (
          <Signature
            title={'证书指引和教学身份签名'}
            filePath={'signature'}
            modified={true}
            oss={ossSignature}
            onSuccess={(imgUrl) => updateSignData({ handwrittenSignatureCandidateUnderstanding6: imgUrl })}
            onClear={() => updateSignData({ handwrittenSignatureCandidateUnderstanding6: '' })}
          />
        )}
        <WhiteSpace size="lg" />
        <p>
          <strong>
            针对本次 IE 教练考试所签署的此份文件，将适用于未来12个月内的任何 IE 教
            练考试。本人已阅读并了解以上的声明，同时，任何有关通过证书规定的问题 皆已获得满意的答复。
          </strong>
        </p>
        {code ? (
          <>
            <Signature
              title={'签名'}
              initSignature={ieSignatureDetail.handwrittenSignatureCandidateUnderstanding7}
              modified={false}
            />
            <div className={styles['sign-date']}>
              签名日期：{formatDate(ieSignatureDetail.handwrittenSignatureCandidateUnderstandingDate, 'YYYY-MM-DD')}
            </div>
          </>
        ) : (
          <>
            <Signature
              title={'签名'}
              filePath={'signature'}
              modified={true}
              oss={ossSignature}
              onSuccess={(imgUrl) => updateSignData({ handwrittenSignatureCandidateUnderstanding7: imgUrl })}
              onClear={() => updateSignData({ handwrittenSignatureCandidateUnderstanding7: '' })}
            />
            <WhiteSpace />
            <Button block type="submit" color="primary" loading={loading} onClick={submit}>
              提交
            </Button>
          </>
        )}
      </WingBlank>
    </div>
  )
}

export default IEStatement
